<template>
	<div>
		<template v-for="(material, index) in materials">
			<AsiCard :key="index" :title="material.title" title-bg-color="transparent" class="mt-3" wrap-title flat no-bottom-margin>
				<v-card-text v-for="(subChapter, secIndex) in material.subChapters" :key="secIndex">
					<h3>{{ subChapter.subtitle }}</h3>
					<div v-for="(section, thiIndex) in subChapter.sections" :key="thiIndex" class="ma-5">
						<h5 v-html="section.sectionTitle"/>
						<p v-html="section.content"/>
					</div>
				</v-card-text>
			</AsiCard>
		</template>
	</div>
</template>

<script lang="ts">
	import Vue from 'vue';
	import {Component} from 'vue-property-decorator';
	import AsiCard from "@/components/common/AsiCard.vue";

	interface Material {
		title: string;
		subChapters: { subtitle: string, sections: { sectionTitle: string, content: string }[] }[];
	}

	@Component({
		components: {AsiCard}
	})
	export default class MaterialsChapters extends Vue {

		private get materials(): Record<string, Material> {
			return this.$t('materials') as unknown as Record<string, Material>;
		}

	}
</script>

<style lang="scss" scoped>

</style>
